export enum Roles {
  Admin = "Admin",
  Client = "Client",
  Provider = "Provider",
}

export const RoleLabels: Record<Roles, string> = {
  [Roles.Admin]: "admin",
  [Roles.Client]: "client",
  [Roles.Provider]: "provider",
};

export const RoleValues = Object.values(Roles) as Roles[];

export default Roles;
